import React, { useEffect, useState } from 'react'
import { FaEdit } from 'react-icons/fa'
import { FaPlus, FaTrash } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import Sidebar from './partial/Sidebar'
import Header from './partial/Header'
import { useAllBlogQuery, useDeleteBlogMutation } from '../../redux/API/BlogApi'
import toast, { Toaster } from 'react-hot-toast'
import DeleteModal from './partial/DeleteModal'
import ChangePassword from './partial/ChangePassword'
import { blogImgUrl, ImgUrl } from '../Constant'

const AdminBlog = () => {
const [newClass, setNewClass] = useState("")
const [newSidebarClass, setNewSidebarClass] = useState("")  
const [showPass, setShowPass] = useState(false)
const [showModal, setShowModal] = useState(false)  
const [deleteId, setDeletId] = useState('')
const {data, refetch} = useAllBlogQuery()    


const [deleteData] = useDeleteBlogMutation()
  const handleShow = (id)  => {
    setDeletId(id)
    setShowModal(true)
  }
  
  
const handleDelete = async () => {
    try {
      await deleteData(deleteId).unwrap(); 
      setShowModal(false);
      refetch();
      toast.success('Blog Deleted Successfully')
    } catch (error) {
      setShowModal(false);
      toast.error("Something went wrong, Please try later")
    }
  };

  const handleToggle = () => {
    if (newClass === "") {
      setNewClass("main-active");
      } else {
        setNewClass("");
        }
        if(newSidebarClass === ""){
          setNewSidebarClass("closed");
        }
        else{
          setNewSidebarClass("");
        }
  }

  useEffect(() => {
    refetch()
  }, [refetch])
  
  return (
    <>
    <Toaster position='top-right'/>
    <Sidebar
    newSidebarClass={newSidebarClass}
    setShowPass={setShowPass}
    />
    <div className={`main-context ${newClass}`}>
      <Header
      handleToggle={handleToggle}
      />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Blogs
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
          <Link to="/admin/addblogs" className="btn btn-primary">
          Add Blog <FaPlus/>
          </Link>
          </div>
          <div className=" card p-4">
           
            <div className="table-wrapper w-100  overflow-x-auto ">
              <table className="table table-bordered ">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Image</th>
                    <th scope="col">Title</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                    {
                      data && data?.data?.allBlogs?.map((i, index) => (

                <tr key={i?._id}>
                    <td>{index+1}</td>
                    <td> <img src={`${ImgUrl}${blogImgUrl}${i?.image}`} alt="Blogs Image" width={80}/></td>
                    <td>{i?.title}</td>
                    <td>
                      <Link to={`/admin/blogs/${i?.slug}`} className='text-black'><FaEdit/></Link>
                      <Link className="text-danger ms-3" onClick={() => handleShow(i._id)}><FaTrash/></Link>
                    </td>
                </tr>
                        ) )
                    }
     

    
                </tbody>
              </table>
            </div>
            {/* <div className="d-flex justify-content-between  align-items-center ">
              <p className="m-0">Showing 1 to 10 of 10 entries</p>
              <div aria-label="Page navigation example">
                <ul className="pagination">
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      Previous
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      1
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      2
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      3
                    </Link>
                  </li>
                  <li className="page-item">
                    <Link className="page-link text-black " href="#">
                      Next
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {
        showModal && (

            <DeleteModal
            title={"Blog"}
            handleDelete={handleDelete}
            setShowModal={setShowModal}
            />
        )
      }
       {
      showPass && (
        <ChangePassword
        setShowPass={setShowPass}
        />
      )
    }
    </>
  )
}

export default AdminBlog